module.exports = __webpack_public_path__ + "static/img/bcg2.64d07b5f.png";